import React from 'react';

export class KeyboardEventUtil {
  static onCheckKeyDownPreventEnter = (e: React.KeyboardEvent) => {
    const enterKye = ['NumpadEnter', 'Enter'];
    if (enterKye.includes(e.code)) e.preventDefault();
  };

  static onCheckKeyDownPreventEnterExceptTextarea = (e: React.KeyboardEvent) => {
    const enterKey = ['NumpadEnter', 'Enter'];
    const target = e.target as HTMLElement;

    if (enterKey.includes(e.code) && target.nodeName !== 'TEXTAREA') e.preventDefault();
  };
}
